// Enregistre le service worker et gère la mise à jour automatique du cache

export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log('[PWA] Service Worker enregistré avec succès :', registration.scope);

          // Vérifier régulièrement les nouvelles versions (toutes les 10 minutes)
          setInterval(() => {
            registration.update();
          }, 10 * 60 * 1000);

          // Vérifier les mises à jour lorsque l'utilisateur revient sur l'application
          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
              registration.update();
            }
          });

          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (installingWorker == null) {
              return;
            }
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  // Nouveau contenu disponible, activer immédiatement
                  console.log('[PWA] Nouvelle version détectée ! Activation en cours...');
                  installingWorker.postMessage({ type: 'SKIP_WAITING' });
                } else {
                  console.log('[PWA] Application mise en cache pour utilisation hors-ligne.');
                }
              }
            };
          };
        })
        .catch((error) => {
          console.error('[PWA] Erreur lors de l\'enregistrement du Service Worker :', error);
        });

      // Lorsque le nouveau Service Worker prend le contrôle, actualiser la page pour charger la dernière version
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
          refreshing = true;
          console.log('[PWA] Mise à jour appliquée, actualisation automatique...');
          window.location.reload();
        }
      });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

